import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import Drawer from '@material-ui/core/Drawer'
import { SideBarMenu } from './components/side-bar'
import { TopBar } from './components/top-bar'
import { Container } from '@material-ui/core'
import { AppRouter } from './routes/AppRouter'
import { IAuthService } from './modules/auth/services/AuthService'
import React, { useEffect, useState } from 'react'
import { LoggedUser } from './modules/auth/models/LoggedUser'
import { getAuthContainer } from './container/auth-modules'
import { AUTH_SERVICE_KEY } from './modules/auth'
import i18n from 'i18next'
import { Login } from './pages/login/Login'
import Imagen from './assets/Home-background.png'
import { Home } from 'pages/login/Home'
import { MaintenanceGuard } from 'MaintenanceGuard'
import logoB from './assets/ReproHealth Nexus.png'

const authService = getAuthContainer().get<IAuthService>(AUTH_SERVICE_KEY)

const App = () => {
  const classes = useStyles()
  const [loggedUser, setLoggedUser] = useState<LoggedUser>(authService.get())
  const [endsWithHome, setEndsWithHome] = useState<boolean>(window.location.href.endsWith('/home'))

  useEffect(() => {
    i18n.changeLanguage(loggedUser.language)
    authService.getObservable().subscribe((u) => {
      setLoggedUser(u)
      i18n.changeLanguage(u.language)
    })
  }, [])

  useEffect(()=> {
      setEndsWithHome(window.location.href.endsWith('/home'))   
  },[window.location])

  return (
        <MaintenanceGuard appSlug='RECEPTIVIDAD PGD' appName='REPROHEALTH' serviceUrl='https://smcguard.bioarray.es' logo={logoB}>

      {loggedUser.id ? (
       endsWithHome ?(
           <div className={classes.image}>
        
          <div className={classes.container}>

            <main className={classes.main2}>
              <Container>
                <Home />
              </Container>
            </main>
          </div>
        </div>
        ):(
        <div className={classes.root }>
         <TopBar />
          <div className={classes.container}>
            <Drawer
              variant="permanent"
              classes={{
                paper: clsx(classes.drawer),
              }}>
              <SideBarMenu />
            </Drawer>
            <main className={classes.main}>
              <Container>
                <AppRouter />
              </Container>
            </main>
          </div>
        </div>)
      ) : (
        <>
          <AppRouter />
          <Login />
        </>
      )}
        </MaintenanceGuard>

  )
}

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  image:{
    backgroundImage: `url(${Imagen})`,
    backgroundSize: 'contain',           
    backgroundPosition: 'top',     
    backgroundRepeat: 'no-repeat',     
    minHeight: '1080px',  
    height: '100vh',  
    backgroundColor: 'white'
      
  },
  container: {
    display: 'flex',
    flex: 1,
  },
  sidebarmenu: {
    marginTop: theme.spacing(5),
  },
  drawer: {
    background: theme.palette.grey.A100,
    position: 'static',
    transition: 'width .7s',
    width: '250px',
  },
  main: {
    flex: 1,
    background: theme.palette.common.white,
    paddingTop: theme.spacing(5),
  },
  main2: {
        flex: 1,
    background: 'rgb(255,255,255,0)',
    paddingTop: theme.spacing(5),
  }
}))

export default App
